import AxiosClient from "../AxiosClient";

export const getBuyer = (params) => {
  const url = "/api/buyer/searchShortInfoList";
  return AxiosClient.post(url, params);
};

export const getBuyerInfo = (params) => {
  const url = "/api/buyer/searchInfoList";
  return AxiosClient.post(url, params);
};

export const insertBuyer = (params) => {
  const url = "/api/buyer/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateBuyer = (params) => {
  const url = "/api/buyer/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteBuyer = (params) => {
  const url = "/api/buyer/deleteInfo";
  return AxiosClient.post(url, params);
};

export const getClosingDateGroups = () => {
  return AxiosClient.get("/api/buyer/closing-date-group");
};

export const getClosingDateGroup = () => {
  return AxiosClient.get("/api/buyer/closing-date-group");
};

export const getClosingDates = () => {
  return AxiosClient.get("/api/buyer/closing-dates");
};


export const downloadBuyerPrintInfo = (requestBody = {}) => {
  const url = `/api/buyer/printInfoList`;
  return AxiosClient.post(url, requestBody, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Error:", error);
    });
};
